import React, { useCallback } from 'react';

import AIVoiceFilterDropdown from './AIVoiceFilterDropdown';

import useAIVoiceFilters from 'js/src/components/app/VoiceSelectionModal/useAIVoiceFilters';
import useAIVoiceSearch from 'js/src/components/app/VoiceSelectionModal/useAIVoiceSearch';
import { PrimaryTextButton } from 'js/src/components/common/ui/Button';
import Checkbox from 'js/src/components/common/ui/Checkbox';

interface AIVoiceAdvancedFiltersProps {
    className?: string;
}

const AIVoiceAdvancedFilters: React.FC<AIVoiceAdvancedFiltersProps> = ({ className }) => {
    const { toneFilterOptions, styleFilterOptions, languageFilterOptions, accentFilterOptions } =
        useAIVoiceFilters();
    const {
        selectedStyle,
        selectedTone,
        selectedLanguage,
        selectedAccent,
        selectedFavourites,
        onChangeTone,
        onChangeStyle,
        onChangeLanguage,
        onChangeAccent,
        onChangeFavourites,
        hasActiveFilters,
        onClearFilters,
    } = useAIVoiceSearch();

    const handleToggleFavourites = useCallback(() => {
        onChangeFavourites();
    }, [onChangeFavourites]);

    const showToneFilter = toneFilterOptions.length > 0;
    const showStyleFilter = styleFilterOptions.length > 0;
    const showLanguageFilter = languageFilterOptions.length > 0;
    const showAccentFilter = accentFilterOptions.length > 0;

    return (
        <div className={className}>
            <div className="row gx-1 align-items-center">
                {showLanguageFilter && (
                    <div className="col-auto">
                        <AIVoiceFilterDropdown
                            options={languageFilterOptions}
                            selectedValue={selectedLanguage}
                            onChange={onChangeLanguage}
                            placeholder="Language"
                        />
                    </div>
                )}
                {showAccentFilter && (
                    <div className="col-auto">
                        <AIVoiceFilterDropdown
                            options={accentFilterOptions}
                            selectedValue={selectedAccent}
                            onChange={onChangeAccent}
                            placeholder="Accent"
                        />
                    </div>
                )}
                {showToneFilter && (
                    <div className="col-auto">
                        <AIVoiceFilterDropdown
                            options={toneFilterOptions}
                            selectedValue={selectedTone}
                            onChange={onChangeTone}
                            placeholder="Tone"
                        />
                    </div>
                )}
                {showStyleFilter && (
                    <div className="col-auto">
                        <AIVoiceFilterDropdown
                            options={styleFilterOptions}
                            selectedValue={selectedStyle}
                            onChange={onChangeStyle}
                            placeholder="Style"
                        />
                    </div>
                )}
                <div className="col-auto ms-l5-8">
                    <Checkbox
                        checked={selectedFavourites}
                        onChange={handleToggleFavourites}
                        text="Favorites only"
                    />
                </div>
                {hasActiveFilters && (
                    <>
                        <div className="col-auto ms-l5-8 border-start filter-separator" />
                        <div className="col-auto ms-l5-8">
                            <PrimaryTextButton text="Clear filters" onClick={onClearFilters} />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default AIVoiceAdvancedFilters;
